<template>
  <UModal
    :open="modelValue"
    :fullscreen="isMobile"
    @update:open="emit('update:modelValue', $event)"
  >
    <template #body>
      <div v-if="showLogin && !showRegister && !showContent">
        <AuthLoginNew :is-modal="isModal" @login-success="showContentModal" />
        <div class="text-center text-sm">
          <i18n-t keypath="auth.login.label" tag="span" scope="global">
            <template #register>
              <ULink :active="true" @click="showRegisterModal()">
                {{ t('auth.login.register') }}
              </ULink>
            </template>
          </i18n-t>
        </div>
      </div>
      <div v-if="!showLogin && showRegister && !showContent">
        <AuthRegisterTraveler
          :is-modal="isModal"
          @login-success="showContentModal"
        >
          <i18n-t
            keypath="auth.registrationTraveler.label"
            tag="span"
            scope="global"
          >
            <template #signUp>
              <ULink :active="true" @click="showLoginModal()">
                {{ t('auth.registrationTraveler.signUp') }}
              </ULink>
            </template>
          </i18n-t>
        </AuthRegisterTraveler>
      </div>
      <slot v-if="!showLogin && !showRegister && showContent" />
    </template>
  </UModal>
</template>
<script setup lang="ts">
import { useUserStore } from '~~/modules/auth/stores/userStore'

const userStore = useUserStore()

const { isMobile } = useDevice()

const isModal = true

const showLogin = ref<boolean>(false)
const showRegister = ref<boolean>(false)
const showContent = ref<boolean>(false)

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const showLoginModal = () => {
  showLogin.value = true
  showRegister.value = false
  showContent.value = false
}

const showRegisterModal = () => {
  showLogin.value = false
  showRegister.value = true
  showContent.value = false
}

const showContentModal = () => {
  showLogin.value = false
  showRegister.value = false
  showContent.value = true
}

const init = async () => {
  const user = userStore.getUserdata
  if (!user.logged) {
    showLoginModal()
  } else {
    showContentModal()
  }
}

const unsubscribe = userStore.$subscribe(() => {
  init()
})
onUnmounted(() => {
  unsubscribe()
})

onMounted(() => {
  init()
})
</script>
